import learningApi from '@src/services/api/learning/index'

export default learningApi.defineApi([
  {
    name: 'getCourses',
    method: 'get',
    url: '/courses'
  },

  {
    name: 'getCourseDetail',
    method: 'get',
    url: '/courses/:courseId'
  }
])
